import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'genesis-frontend-dynamic-heading',
    styleUrls: ['./dynamic-heading.component.scss'],
    template: `
      <ng-container [ngSwitch]="level">
          <h1 *ngSwitchCase="1"
              [id]="id"
              [class]="className"
              [innerHTML]="content"
              [attr.aria-describedby]="describedBy || null"
              [attr.aria-hidden]="ariaHidden || null"></h1>
          <h2 *ngSwitchCase="2"
              [id]="id"
              class="dynamic-heading"
              [class]="className"
              [innerHTML]="content"
              [attr.aria-describedby]="describedBy || null"
              [attr.aria-hidden]="ariaHidden || null"></h2>
          <h3 *ngSwitchCase="3"
              [id]="id"
              class="dynamic-heading"
              [class]="className"
              [innerHTML]="content"
              [attr.aria-describedby]="describedBy || null"
              [attr.aria-hidden]="ariaHidden || null"></h3>
          <h4 *ngSwitchCase="4"
              [id]="id"
              class="dynamic-heading"
              [class]="className"
              [innerHTML]="content"
              [attr.aria-describedby]="describedBy || null"
              [attr.aria-hidden]="ariaHidden || null"></h4>
          <h5 *ngSwitchCase="5"
              [id]="id"
              class="dynamic-heading"
              [class]="className"
              [innerHTML]="content"
              [attr.aria-describedby]="describedBy || null"
              [attr.aria-hidden]="ariaHidden || null"></h5>
          <h6 *ngSwitchCase="6"
              [id]="id"
              class="dynamic-heading"
              [class]="className"
              [innerHTML]="content"
              [attr.aria-describedby]="describedBy || null"
              [attr.aria-hidden]="ariaHidden || null"></h6>
      </ng-container>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynamicHeadingComponent {
  @Input() level: 1 | 2 | 3 | 4 | 5 | 6 = 2;
  @Input() className = '';
  @Input() id = '';
  @Input() content = '';
  @Input() describedBy = '';
  @Input() ariaHidden?: boolean;
}
